import Schema from './Schema'
import FieldDatetime from '../fields/FieldDatetime'

const ts2date = ts => new Date(ts * 1000)
const addLeadingZero = t => (t < 10 ? '0' : '') + t.toString()

export default class SchemaDatetime extends Schema {
  constructor(label, key, rules, options = {}, on = {}) {
    options.render = options.render || (date => {
      if (!date) {
        return '/'
      }
      if (typeof date === 'number') {
        date = ts2date(date)
      }
      const year = addLeadingZero(date.getYear() + 1900)
      const month = addLeadingZero(date.getMonth() + 1)
      const day = addLeadingZero(date.getDate())
      const hour = addLeadingZero(date.getHours())
      const minute = addLeadingZero(date.getMinutes())
      const second = addLeadingZero(date.getSeconds())
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    })
    super(options)
    FieldDatetime.call(this, label, key, rules, options, on)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaDatetime.js